import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { BLOCKS } from "@contentful/rich-text-types";
import React, { useState, useEffect } from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import ModuleCard from '../../atoms/module-card/module-card';
import './section-meet-modules.scss';

const SectionMeetModules = ({ contentInfo }) => {

    const [pageLoad, setPageLoad] = useState(false);

    const title = {
        renderNode: {
            [BLOCKS.HEADING_2]: (node, next) => <h2 className="f-m-meet-modules__title">{next}</h2>
        }
    };

    const NextArrow = (props) => {
        const { onClick } = props;
        return (
            <span
                className={"f-m-slider-meet-modules-next"}
                onClick={onClick}
            />
        );
    }
    const PrevArrow = (props) => {
        const { onClick } = props;

        return (
            <span
                className={"f-m-slider-meet-modules-prev"}
                onClick={onClick}
            />
        );
    }

    const settings = {
        dots: false,
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        speed: 250,
        swipeToSlide: true,
        draggable: true,
        arrows: true,
        prevArrow: <PrevArrow />,
        nextArrow: <NextArrow />,
        responsive: [
            {
                breakpoint: 1023,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true,
                    arrows: false

                }
            }
        ]
    }


    useEffect(() => {
        setPageLoad(true)
    }, []);

    return (
        <section className="f-m-meet-modules">
            <div className="f-m-meet-modules__content">
                <div className="f-m-meet-modules__title-continer">{contentInfo.descripcion.raw && documentToReactComponents(JSON.parse(contentInfo.descripcion.raw), title)}</div>
                <div className="f-m-meet-modules__info">
                    <h3 className="f-m-meet-modules__subtitle">{contentInfo.tituloGeneral}</h3>
                    <div className="f-m-meet-modules__slider-container-wrapper">
                        <div className="f-m-meet-modules__slider-container">
                            {pageLoad &&
                                <Slider {...settings} className="f-m-caretakers-features__slider">
                                    {contentInfo.listaContenidos && contentInfo.listaContenidos.map((info, index) => {
                                        let url_string = window.location.href
                                        let url_divided = url_string.split("/")
                                        if (url_divided[url_divided.length - 2] != info.redireccionBoton.replace("/", "")) { return <ModuleCard key={index} item={info} /> }
                                    })}
                                </Slider>
                            }
                        </div>
                    </div>

                </div>
            </div>
        </section>
    )
}

export default SectionMeetModules
